import { render, staticRenderFns } from "./activity2023.vue?vue&type=template&id=3dc2c20a&scoped=true&"
import script from "./activity2023.vue?vue&type=script&lang=js&"
export * from "./activity2023.vue?vue&type=script&lang=js&"
import style0 from "./activity2023.vue?vue&type=style&index=0&id=3dc2c20a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc2c20a",
  null
  
)

export default component.exports